function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  featurekey: "rootContainer",
  transform: "matrix(1,0,0,1,0,0)",
  fill: "#fff"
}, React.createElement("rect", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 240,
  height: 232,
  rx: 10,
  ry: 10
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  featurekey: "q4o0QG-0",
  transform: "matrix(12.78772350445547,0,0,12.78772350445547,15.140666272595116,-45.21741304383748)",
  fill: "#111"
}, React.createElement("path", {
  d: "M5.72 5.119999999999999 l1.64 0.48 l0.22 0.76 l0.14 2.64 l-0.12 0.94 l-1.36 -0.04 l-1.64 0.06 l0 -0.82 l-0.18 -1.06 l-2.32 -0.02 l-0.22 0.58 l0.2 2.24 l1.46 0.04 c0.78 0.02 1.54 0.04 1.7 0.1 c0.1 0.06 0.66 0.08 1.22 0.14 l1.04 0.06 l0.22 3.36 l0 1.74 l-0.18 3.02 l-1.58 0.76 l-3.86 0.04 l-1.38 -0.66 l-0.34 -1.78 l0.08 -2.68 l0.06 -0.82 l0.76 0.04 l1.68 0.22 l0.06 2.8 l1.82 0.14 l0.06 -4.08 l-1.22 -0.04 l-1.46 -0.04 l-1.52 -0.4 l-0.18 -4.26 l0.28 -2.88 l1.94 -0.6 z M8.620000000000001 9.22 l0.6 -3.94 l5.82 -0.12 l0.62 0 l0.36 1.76 l0 0.54 l-3.56 10.98 l3.14 -0.2 l0 1.84 l-4.22 0.06 l-2.98 -0.16 l-0.16 -0.7 l0.24 -1.5 l3.98 -9.22 z"
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 240 232",
    preserveAspectRatio: "xMidYMid meet",
    className: "css-g5ufxp",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.d904367d.svg";
export { ForwardRef as ReactComponent };